import styled from 'styled-components'
import { COLOURS, BREAKPOINTS } from 'resources'
import RoundedButton from 'components/RoundedButton'

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  text-align: left;
  max-width: 550px;
  width: 100%;
  margin: 50px 0;
`

export const Title = styled.span`
  font-family: 'Druk', sans-serif;
  font-size: 60px;
  line-height: 1;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 70px;
  }
`

export const CardDescription = styled.div`
  margin-top: 20px;
  font-size: 18px;

  @media (min-width: ${BREAKPOINTS.md}) {
    font-size: 20px;
  }
`

export const SupportLink = styled.a`
  font-size: 18px;
  color: ${COLOURS.primaryBlue};
  transition: 0.2s color;
  &:hover {
    text-decoration: none;
    opacity: 0.7;
  }
`

export const DescriptionPadded = styled.div`
  padding-bottom: 8px;
`

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;
  flex-direction: column;

  @media (min-width: ${BREAKPOINTS.md}) {
    flex-direction: row;
  }
`
export const SupportRegionButton = styled(RoundedButton)`
  width: 100%;
  margin-top: 10px;
  @media (min-width: ${BREAKPOINTS.md}) {
    max-width: 250px;
    margin-top: 0;
  }
`
export const ContactSupportButton = styled(RoundedButton)`
  width: 100%;
  margin-top: 10px;
  @media (min-width: ${BREAKPOINTS.md}) {
    max-width: 250px;
    margin-left: 15px;
    margin-top: 0;
  }
`
